export default "__VITE_ASSET__CanM5$vw__"